// extracted by mini-css-extract-plugin
module.exports = {"roadmap":"style_roadmap__2I861","scrollableArea":"style_scrollableArea__3j9Oa","timeline":"style_timeline__dP6lj","date":"style_date__G0jE9"};